import { render, staticRenderFns } from "./B4.vue?vue&type=template&id=b4e815f6&scoped=true&"
import script from "./B4.vue?vue&type=script&lang=js&"
export * from "./B4.vue?vue&type=script&lang=js&"
import style0 from "./B4.vue?vue&type=style&index=0&id=b4e815f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e815f6",
  null
  
)

export default component.exports